// ============================================
// FILE: frontend/src/services/api.js
// API SERVICE - ALL API CALLS
// ============================================

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Helper function for API calls
const apiCall = async (endpoint, options = {}) => {
  const token = localStorage.getItem('authToken');
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };

  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Something went wrong');
    }

    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

// ============================================
// AUTHENTICATION API
// ============================================

export const authAPI = {

  // login with Send otp

   sendOTPForLogin: async (mobile,password,method = 'sms') => {
   // alert("api call mobile:"+mobile+" password:"+password+" method:"+method);
    const response = apiCall('/login/mobile', {
      method: 'POST',
      body: JSON.stringify({ mobile, password })
    });
    // alert("api call response:"+response.data);    
    return response;
  },

  // Send OTP
  sendOTP: async (mobile, method = 'sms') => {
    return apiCall('/auth/send-otp', {
      method: 'POST',
      body: JSON.stringify({ mobile, method })
    });
  },

  // Verify OTP
  verifyOTP: async (mobile, otp) => {
    const data = await apiCall('/auth/verify-otp', {
      method: 'POST',
      body: JSON.stringify({ mobile, otp })
    });
    
    if (data.token) {
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
    
    return data;
  },

  // Email Login
  login: async (email, password) => {
    const data = await apiCall('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password })
    });
    
    if (data.token) {
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
    
    return data;
  },

  // Register
  register: async (userData) => {
    const data = await apiCall('/auth/register', {
      method: 'POST',
      body: JSON.stringify(userData)
    });
    
    if (data.token) {
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
    
    return data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  // Get current user
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }
};

// ============================================
// PRODUCTS API
// ============================================

export const productsAPI = {
  // Get all products
  getAll: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return apiCall(`/products${queryString ? `?${queryString}` : ''}`);
  },

  // Get single product
  getById: async (id) => {
    return apiCall(`/products/${id}`);
  },

  // Search products
  search: async (query) => {
    return apiCall(`/products?search=${encodeURIComponent(query)}`);
  },

  // Get by category
  getByCategory: async (category) => {
    return apiCall(`/products?category=${encodeURIComponent(category)}`);
  }
};

// ============================================
// CART API (Local Storage for now)
// ============================================

export const cartAPI = {
  // Get cart
  get: () => {
    const cart = localStorage.getItem('cart');
    return cart ? JSON.parse(cart) : [];
  },

  // Add to cart
  add: (product) => {
    const cart = cartAPI.get();
    const existing = cart.find(item => item.id === product.id);
    
    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }
    
    localStorage.setItem('cart', JSON.stringify(cart));
    return cart;
  },

  // Update quantity
  updateQuantity: (productId, quantity) => {
    let cart = cartAPI.get();
    cart = cart.map(item => 
      item.id === productId ? { ...item, quantity } : item
    ).filter(item => item.quantity > 0);
    
    localStorage.setItem('cart', JSON.stringify(cart));
    return cart;
  },

  // Remove from cart
  remove: (productId) => {
    let cart = cartAPI.get();
    cart = cart.filter(item => item.id !== productId);
    localStorage.setItem('cart', JSON.stringify(cart));
    return cart;
  },

  // Clear cart
  clear: () => {
    localStorage.removeItem('cart');
    return [];
  },

  // Get total
  getTotal: () => {
    const cart = cartAPI.get();
    return cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  }
};

// ============================================
// ORDERS API
// ============================================

export const ordersAPI = {
  // Create order
  
  create: async (orderData) => {
    console.log("API Order Data:"+JSON.stringify(orderData));
    return apiCall('/orders', {
      method: 'POST',
      body: JSON.stringify(orderData)
    });
  },

  // Get user orders
  getMyOrders: async () => {
    return apiCall('/orders/my-orders');
  },

  // Get single order
  getById: async (orderId) => {
    return apiCall(`/orders/${orderId}`);
  },

  // Cancel order
  cancel: async (orderId) => {
    return apiCall(`/orders/${orderId}/cancel`, {
      method: 'PATCH'
    });
  }
};

// ============================================
// PAYMENTS API
// ============================================

export const paymentsAPI = {
  // Create Razorpay order
  createRazorpayOrder: async (amount) => {
    return apiCall('/payments/create-order', {
      method: 'POST',
      body: JSON.stringify({ amount, currency: 'INR' })
    });
  },

  // Verify payment
  verifyPayment: async (paymentData) => {
    return apiCall('/payments/verify-payment', {
      method: 'POST',
      body: JSON.stringify(paymentData)
    });
  },

  // Process COD
  processCOD: async (orderId) => {
    return apiCall('/payments/cod', {
      method: 'POST',
      body: JSON.stringify({ orderId })
    });
  },

  // Get payment history
  getHistory: async () => {
    return apiCall('/payments/history');
  }
};

// ============================================
// SUBSCRIPTIONS API
// ============================================

export const subscriptionsAPI = {
  // Create subscription
  create: async (subscriptionData) => {
    console.log("API Subscription Data:"+JSON.stringify(subscriptionData));
    return apiCall('/subscriptions', {
      method: 'POST',
      body: JSON.stringify(subscriptionData)
    });
  },

  // Get user subscriptions
  getMy: async () => {
    return apiCall('/subscriptions');
  },

  // Get single subscription
  getById: async (id) => {
    return apiCall(`/subscriptions/${id}`);
  },

  // Pause subscription
  pause: async (id) => {
    return apiCall(`/subscriptions/${id}/pause`, {
      method: 'PATCH'
    });
  },

  // Resume subscription
  resume: async (id) => {
    return apiCall(`/subscriptions/${id}/resume`, {
      method: 'PATCH'
    });
  },

  // Cancel subscription
  cancel: async (id) => {
    return apiCall(`/subscriptions/${id}`, {
      method: 'DELETE'
    });
  },

  // Update plan
  updatePlan: async (id, planData) => {
    return apiCall(`/subscriptions/${id}/plan`, {
      method: 'PATCH',
      body: JSON.stringify(planData)
    });
  }
};

// ============================================
// USER API
// ============================================

export const userAPI = {
  // Get profile
  getProfile: async () => {
    return apiCall('/users/profile');
  },

  // Update profile
  updateProfile: async (profileData) => {
    return apiCall('/users/profile', {
      method: 'PUT',
      body: JSON.stringify(profileData)
    });
  },

  // Upload profile picture
  uploadProfilePic: async (file) => {
    const formData = new FormData();
    formData.append('profilePic', file);
    
    const token = localStorage.getItem('authToken');
    
    const response = await fetch(`${API_URL}/users/profile-picture`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });
    
    return response.json();
  },

  // Change password
  changePassword: async (currentPassword, newPassword) => {
    return apiCall('/users/change-password', {
      method: 'POST',
      body: JSON.stringify({ currentPassword, newPassword })
    });
  },

  // Get user stats
  getStats: async () => {
    return apiCall('/users/stats');
  }
};

// ============================================
// SECURITY API
// ============================================

export const securityAPI = {
  // Log security event
  logEvent: async (action, detail, type = 'info') => {
    return apiCall('/security/log', {
      method: 'POST',
      body: JSON.stringify({ action, detail, type })
    });
  },

  // Get security logs
  getLogs: async () => {
    return apiCall('/security/logs');
  },

  // Get active devices
  getDevices: async () => {
    return apiCall('/security/devices');
  },

  // Logout device
  logoutDevice: async (deviceId) => {
    return apiCall(`/security/devices/${deviceId}`, {
      method: 'DELETE'
    });
  },

  // Logout all devices
  logoutAll: async (currentDeviceId) => {
    return apiCall('/security/logout-all', {
      method: 'POST',
      body: JSON.stringify({ currentDeviceId })
    });
  }
};

// ============================================
// SUPPORT API
// ============================================

export const supportAPI = {
  // Submit support ticket
  submitTicket: async (ticketData) => {
    return apiCall('/support/tickets', {
      method: 'POST',
      body: JSON.stringify(ticketData)
    });
  },

  // Get FAQs
  getFAQs: async (category) => {
    return apiCall(`/support/faqs${category ? `?category=${category}` : ''}`);
  },

  // Search FAQs
  searchFAQs: async (query) => {
    return apiCall(`/support/faqs/search?q=${encodeURIComponent(query)}`);
  }
};

// ============================================
// SETTINGS API
// ============================================

export const settingsAPI = {
  // Get app settings/configuration
  getSettings: async () => {
    try {
      console.log('settingsAPI: Attempting to fetch from /settings');
      return await apiCall('/settings');
    } catch (error) {
      console.error('settingsAPI: /settings failed, trying /config');
      try {
        return await apiCall('/config');
      } catch (configError) {
        console.error('settingsAPI: /config failed, trying /app/settings');
        try {
          return await apiCall('/app/settings');
        } catch (appError) {
          console.error('settingsAPI: All settings endpoints failed');
          throw new Error('Unable to fetch settings from any endpoint');
        }
      }
    }
  },

  // Get specific setting
  getSetting: async (key) => {
    return apiCall(`/settings/${key}`);
  },

  // Get app configuration (alternative endpoint)
  getAppConfig: async () => {
    try {
      return await apiCall('/config/app');
    } catch (error) {
      console.error('settingsAPI: Failed to get app config:', error);
      throw error;
    }
  }
};
